import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="5" width="18" height="12" rx="2" />
    <path d="M7 20L17 20" strokeLinecap="round" />
    <path d="M10 17L10 20" strokeLinecap="round" />
    <path d="M14 17L14 20" strokeLinecap="round" />
    <path
      d="M9.63904 9L10 9.48789L8.75401 11.0305L10 12.5121L9.63904 13L8 11.0305L9.63904 9Z"
      fill="#C3CCD5"
    />
    <path d="M12.309 9H13L11.6878 13H11L12.309 9Z" fill="#C3CCD5" />
    <path
      d="M15.2487 11.03L14 9.51454L14.3316 9L16 11.03L14.3316 13L14 12.4855L15.2487 11.03Z"
      fill="#C3CCD5"
    />
  </svg>
);
